/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ClaimTradingChallengePrizeOptions,
  ClaimTradingChallengePrizeResponses,
} from '../types/ClaimTradingChallengePrize'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Claim an eligible trading challenge prize. TOURNAMENT requires completed KYC, credits the crown prize, reactivates the account, and marks the result PRIZE_CLAIMED. CASH requires completed KYC, winds down the account, sweeps remaining challenge credit, awards CASH_CROWN, and marks the result PRIZE_CLAIMED; the account stays deactivated with a zero balance. QR_PROMO accepts an eligible reward request before KYC, winds down the account, fixes the capped reward, queues a KYC email, and records REWARD_PENDING_KYC without paying the reward or reactivating the account.
 * @summary Claim challenge prize
 * {@link /v1/trading_challenges/:trading_challenge_id/claim}
 */
export function claimTradingChallengePrize<ThrowOnError extends boolean = true>(
  options: Options<ClaimTradingChallengePrizeOptions, ThrowOnError>,
): Unwrappable<RequestResult<ClaimTradingChallengePrizeResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/trading_challenges/{trading_challenge_id}/claim',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ClaimTradingChallengePrizeResponses, ThrowOnError>>,
  )
}
